/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Informace o skryté virtuální klávesnici.
 * @implements {VirtualKeyboardInfo}
 */
class VirtualKeyboardHidden {
  /** @inheritdoc */
  getHeight() {
    return '0';
  }

  /** @inheritdoc */
  isDisplayed() {
    return false;
  }

  /** @inheritdoc */
  isOverlapping() {
    return false;
  }
}

export default VirtualKeyboardHidden;
